<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>{{ 'Dashboard.DeliveryMethodsStatistic' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        @if (items.length > 0) {
            <div>
                <table>
                    @for (item of locationPaperGroupStatistic; track item) {
                        <tr>
                            <td>{{ item.label }}</td>
                            <td class="text-right">{{ item.total | slNumber }}</td>
                        </tr>
                    }
                    <tr>
                        <td class="pt-1">
                            <strong>{{ 'DeliveryMethods.Total' | translate }} {{ paperTotalLabel }}</strong>
                        </td>
                        <td class="pt-1 text-right">
                            <strong>{{ paperTotal | slNumber }}</strong>
                        </td>
                    </tr>
                </table>
                <table class="mt-3">
                    <tr>
                        <th></th>
                        @for (column of languages; track column) {
                            <th class="text-right">{{ column }}</th>
                        }
                    </tr>
                    @for (item of deliveryMethods; track item) {
                        <tr>
                            <td>{{ item }}</td>
                            @for (column of languages; track column) {
                                <td class="text-right">{{ getData(column, item) | slNumber }}</td>
                            }
                        </tr>
                    }
                </table>
            </div>
        }
    </mat-card-content>

    <mat-card-footer>
        <p>{{ 'DeliveryMethods.Footnote' | translate }}</p>
    </mat-card-footer>
</mat-card>
